import React from 'react';
import styled, { css } from 'styled-components';
import { GLOBALS } from '../../utils/globals';

import Logo from '../atoms/Logo';
import GlowBlue from '../../svg/StrahlenBlau.svg';
import GlowYellow from '../../svg/StrahlenGelb.svg';

interface HeaderProps {
  disableLogo?: boolean;
}

const StyledBackground = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin-left: auto;
  margin-right: auto;
  max-width: var(--max-width-m);
  height: auto;
  background-color: var(--color-accent-background);
  overflow: hidden;
  z-index: 1;
`;

const StyledLogo = styled(Logo)`
  position: relative;
  margin-top: var(--distance-4xs);
`;

const GlowStyles = css`
  position: absolute;
  top: var(--distance-5xs);
  right: 0;
  left: 0;
`;

const StyledGlowBlue = styled(GlowBlue)`
  ${GlowStyles}
`;

const StyledGlowYellow = styled(GlowYellow)`
  ${GlowStyles}
`;

const Header = ({ disableLogo }: HeaderProps) => {
  return (
    <StyledBackground>
      {GLOBALS.theme === 'yellow' ? <StyledGlowYellow /> : <StyledGlowBlue />}
      {!disableLogo && <StyledLogo />}
    </StyledBackground>
  );
};

export default Header;
